import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { toggleButtonGroupClasses } from "@mui/material/ToggleButtonGroup";
import { Material } from "../../../external-library/material/Material";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Draw } from "ol/interaction";
import { getArea, getLength } from "ol/sphere";
import { Style, Stroke, Fill } from "ol/style";
import { LineString, Point, Polygon } from "ol/geom";
import { unByKey } from "ol/Observable";

const StyledToggleButtonGroup = styled(Material.ToggleButtonGroup)(
  ({ theme }) => ({
    [`& .${toggleButtonGroupClasses.grouped}`]: {
      margin: theme.spacing(0.5),
      border: 0,
      borderRadius: theme.shape.borderRadius,
      [`&.${toggleButtonGroupClasses.disabled}`]: {
        border: 0,
      },
    },
    [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
      {
        marginLeft: -1,
        borderLeft: "1px solid transparent",
      },
  })
);
let draw;
let vectorLayer;

export default function Measurment({ mapInstance, isMeasure }) {
  const [measurmentType, setMeasurmentType] = useState("");
  const [measurementValue, setMeasurementValue] = useState("");
  const vectorSource = new VectorSource();

  const layer = new VectorLayer({
    source: vectorSource,
    style: new Style({
      stroke: new Stroke({
        color: "rgba(0, 0, 0, 1)", // Line color
        width: 2, // Line width
        lineDash: [10, 10], // Dashed pattern: 10px dash, 10px gap
      }),
      fill: new Fill({
        color: "rgba(6, 250, 238, 0.1)", // Fill color (for polygons)
      }),
    }),
    zIndex:5
  });
  let listener;
  useEffect(() => {
    // Add drawing functionality
    if (isMeasure) {
      if (draw) {
        mapInstance.removeInteraction(draw);
      }
      if (vectorLayer) {
        mapInstance?.removeLayer(vectorLayer);
      }
      if (measurmentType) {
        vectorLayer = layer;
        mapInstance.addLayer(vectorLayer);
        const addDrawInteraction = () => {
          if (draw) {
            mapInstance.removeInteraction(draw);
          }

          draw = new Draw({
            source: vectorSource,
            type: measurmentType,
          });

          draw.on("drawstart", function (evt) {
            let sketch = evt.feature;
            listener = sketch.getGeometry().on("change", function (evt) {
              const geom = evt.target;
              if (geom instanceof Polygon) {
                setMeasurementValue(formatArea(geom));
              } else if (geom instanceof LineString) {
                setMeasurementValue(formatLength(geom));
              }
            });
          });

          draw.on("drawend", function () {
            unByKey(listener);
          });

          mapInstance.addInteraction(draw);
        };

        addDrawInteraction();
      } else {
        if (draw) {
          mapInstance.removeInteraction(draw);
        }
        if (vectorLayer) {
          mapInstance?.removeLayer(vectorLayer);
        }
        setMeasurementValue("");
      }
    } else {
      setMeasurmentType("");
      setMeasurementValue("");
      if (draw) {
        mapInstance?.removeInteraction(draw);
      }
      if (vectorLayer) {
        mapInstance?.removeLayer(vectorLayer);
      }
    }
  }, [measurmentType, isMeasure]);

  const formatLength = (line) => {
    const length = getLength(line);
    return length > 1000
      ? (length / 1000).toFixed(2) + " km"
      : length.toFixed(2) + " m";
  };

  const formatArea = (polygon) => {
    const area = getArea(polygon);
    return area.toFixed(2) + " m²";
  };

  const handleMeasurmentType = (event, type) => {
    console.log(type);
    setMeasurmentType(type);
  };

  return (
    <>
      <div
        className="col-12 p-2 fw-bold"
        style={{ fontSize: "1rem", backgroundColor: "#ecf2ff" }}
      >
        Measur length and area
      </div>
      <div className="col-12 px-2 d-flex flex-column">
        <span className="me-1" style={{ fontSize: ".800rem", fontWeight: 600 }}>
          Select Measurement Type:
        </span>
        <Material.Paper
          elevation={0}
          sx={(theme) => ({
            display: "flex",
            maxWidth: 95,
            mt: 0.5,
            border: `2px solid ${theme.palette.divider}`,
            flexWrap: "wrap",
          })}
        >
          <StyledToggleButtonGroup
            size="small"
            value={measurmentType}
            exclusive
            onChange={handleMeasurmentType}
            aria-label="text alignment"
          >
            <Material.ToggleButton value="LineString" aria-label="centered">
              <Material.Tooltip title="Measure Length" arrow placement="bottom">
                <Material.StraightenIcon />
              </Material.Tooltip>
            </Material.ToggleButton>
            <Material.ToggleButton value="Polygon" aria-label="left aligned">
              <Material.Tooltip title="Measure Area" arrow placement="bottom">
                <Material.SquareFootIcon />
              </Material.Tooltip>
            </Material.ToggleButton>
          </StyledToggleButtonGroup>
        </Material.Paper>
      </div>

      <div className="col-12 p-2 d-flex flex-column ">
        <span className="px-1" style={{ fontSize: ".800rem", fontWeight: 500 }}>
          Measurment Value
        </span>
        <span className="px-1" style={{ fontSize: ".600rem", fontWeight: 500 }}>
          {measurementValue == "" ? (
            <span className="text-danger">No measurment present</span>
          ) : (
            measurementValue
          )}
        </span>
      </div>
    </>
  );
}
